import { render, staticRenderFns } from "./DonationDetailsModal.vue?vue&type=template&id=afd0931c&"
import script from "./DonationDetailsModal.vue?vue&type=script&lang=js&"
export * from "./DonationDetailsModal.vue?vue&type=script&lang=js&"
import style0 from "./DonationDetailsModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports